import React from 'react';
import { Route, Switch } from 'react-router-dom';

import AllPumps from '../../components/AllPumps';
import PumpTable from '../../components/PumpTable';

const Audit = ({ match }) => {
  return (
    <div className="w-100 h-100">
      <Switch>
        <Route
          path={match.url}
          exact
          render={(props) => {
            return <AllPumps {...props} />;
          }}
        />
        <Route
          path={`${match.url}/:pumpId`}
          exact
          render={(props) => {
            return <PumpTable {...props} />;
          }}
        />
      </Switch>
    </div>
  );
};

export default Audit;
